"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("@airstudio/state");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const searchQuery_1 = require("./searchQuery");
const workspace_1 = require("./workspace");
exports.useResourceListQuery = ({ path }) => {
    const dispatch = react_redux_1.useDispatch();
    const [searchQuery, setSearchQuery] = searchQuery_1.useSearchQuery();
    const workspaceId = workspace_1.useWorkspace();
    const { errorMessage, isProcessing } = react_redux_1.useSelector(state_1.Selectors.Entities.state(path));
    const resources = react_redux_1.useSelector(state_1.Selectors.Entities.getItems(path));
    react_1.useEffect(() => {
        if (true /*workspaceId*/) {
            state_1.Operations.Entities.fetch(dispatch)(workspaceId, path, searchQuery);
        }
    }, [workspaceId, searchQuery.page, searchQuery.query, searchQuery.size, searchQuery.sort]);
    const handleSearch = (query) => {
        setSearchQuery(Object.assign(Object.assign({}, searchQuery), { page: undefined, query }));
    };
    const handlePageChange = (page) => {
        setSearchQuery(Object.assign(Object.assign({}, searchQuery), { page: page - 1 }));
    };
    return {
        errorMessage,
        isProcessing,
        resources,
        handleSearch,
        handlePageChange,
        searchQuery,
    };
};
//# sourceMappingURL=resourceListQuery.js.map